import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Compact notice action, filled with its enclosing notice's border color.
 * The feedback family owns that color once; apps supply only behavior and copy.
 */
import { useRender } from '@base-ui/react/use-render';
import { Button, buttonVariants } from './button.js';
import { cn } from './cn.js';
/** Reuses Button by default; navigation keeps native link semantics through
 * render. A disabled action always renders a disabled button: a link has no
 * disabled state, and its destination would still open from middle-click,
 * "Open in new tab" or long-press. */
export function NoticeAction({ className, render, type = 'button', disabled, ref, ...props }) {
    const asButton = render === undefined || disabled === true;
    return useRender({
        render: asButton ? _jsx(Button, { size: "xs" }) : render,
        ref,
        defaultTagName: 'button',
        props: {
            ...props,
            type: asButton ? type : undefined,
            disabled: asButton ? disabled : undefined,
            'data-slot': 'notice-action',
            // Declares the ::after tap area below, so the brand guide's target-size check counts it.
            'data-tap-area': '',
            className: cn(buttonVariants({ variant: 'secondary', size: 'xs' }), 'relative h-[max(1.75rem,calc(1lh+0.5rem))] shrink-0 border-transparent bg-[var(--feedback-border,var(--color-border-default))] text-caption text-text-primary', 'hover:border-[var(--feedback-border,var(--color-border-default))] hover:bg-[var(--feedback-action-hover,var(--color-border-control))]', 'disabled:hover:border-transparent disabled:hover:bg-[var(--feedback-border,var(--color-border-default))]', 
            // A 28 px face grows with enlarged text; its touch area adds 16 px.
            'pointer-coarse:min-h-7 pointer-coarse:after:absolute pointer-coarse:after:inset-x-0 pointer-coarse:after:-inset-y-2', className),
        },
    });
}
//# sourceMappingURL=notice-action.js.map